import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import FlashFeed from '@/pages/home/components/FlashFeed';
import HotBoard from '@/pages/home/components/HotBoard';
import FocusCovers from '@/pages/home/components/FocusCovers';
import TopicCloud from '@/pages/home/components/TopicCloud';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 text-foreground-950 font-body">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <FlashFeed />
        <HotBoard />
        <FocusCovers />
        <TopicCloud />
      </main>
      <SiteFooter />
    </div>
  );
}